import React, { useEffect, useState } from "react";
import CardCarousel from "./components/Card";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { MdAdd } from "react-icons/md";

const Carousel = () => {
  const navigate = useNavigate();
  const [carousels, setCarousels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCarouselsData = async () => {
      try {
        const response = await axios.get(`/api_w/carousels`, {
          headers: { db_name: process.env.REACT_APP_DB_NAME },
        });
        setCarousels(response.data.data);
      } catch (error) {
        toast.error("Error fetching carousel data: " + (error.response?.data?.message || error.message));
      } finally {
        setLoading(false);
      }
    };
    fetchCarouselsData();
  }, []);

  const handleDelete = (deletedId) => {
    setCarousels((prev) => prev.filter((item) => item.id !== deletedId));
  };

  return (
    <div className="mt-5 px-2">
      {/* Page Header */}
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-2xl font-bold text-navy-700 dark:text-white">Manajemen Carousel</h2>
          <p className="text-sm text-gray-500 mt-1">Kelola gambar dan video banner halaman utama</p>
        </div>
        <button
          onClick={() => navigate("/admin/add-carousel")}
          className="flex items-center gap-2 rounded-xl px-5 py-3 text-sm font-bold text-white shadow-sm transition-colors"
          style={{ background: "linear-gradient(to right, #16a34a, #15803d)" }}
        >
          <MdAdd className="h-5 w-5" />
          Tambah Carousel
        </button>
      </div>

      {loading ? (
        <div className="py-16 text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-brand-500 border-r-transparent" />
          <p className="mt-3 text-sm text-gray-500">Memuat data...</p>
        </div>
      ) : carousels.length === 0 ? (
        <div className="rounded-2xl bg-white shadow-sm p-16 text-center dark:bg-navy-700">
          <p className="text-gray-400">Belum ada carousel. Tambahkan carousel baru.</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {carousels.map((item) => (
            <CardCarousel
              key={item.id}
              id={item.id}
              url={item.url.split(",")[0]}
              type={item.type}
              title={item.title}
              onDelete={handleDelete}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Carousel;
